<template>
<svg viewBox="0 0 15 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-DianZan`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_7161d2ce4a__clip0_1540_3784)"><path d="M4.43111 2.33398C2.6592 2.33398 1.22278 3.77041 1.22278 5.54232C1.22278 8.75065 5.01445 11.6673 7.05611 12.3458C9.09778 11.6673 12.8894 8.75065 12.8894 5.54232C12.8894 3.77041 11.453 2.33398 9.68111 2.33398C8.59602 2.33398 7.63673 2.87266 7.05611 3.69718C6.47549 2.87266 5.5162 2.33398 4.43111 2.33398Z" stroke="#000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="svg_7161d2ce4a__clip0_1540_3784"><path transform="translate(.056)" d="M0 0H14V14H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconDianZan',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
